/**
 * This guard to protect unautheticated user to enter page
 * e.g home, upcoming, setting, email itinerary and account
 */

import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from '@app/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(public storageService: StorageService,
              private router: Router) {  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.storageService.getDevice().then((device) => {
        if (!device) {
          this.router.navigate(['/signup'], { replaceUrl: true });
          return false;
        } else {
          return true;
        }
      });
  }
  async canLoad() {
    return this.storageService.getDevice().then((device) => {
      if (device) {
        this.router.navigate(['/tabs'], { replaceUrl: true });
        return false;
      } else {
        return true;
      }
    });
  }
}
